import { KhRepoKnowledgeItemRow } from "../models/kh-repo.models";
import KhRepoExpandableText, { KhRepoCollapsedItem } from "./KhRepoExpandableText";

type KhRepoKnowledgeExpandableTextProps = {
  rawContent: KhRepoKnowledgeItemRow[];
  variant?: "card" | "inline";
  title?: string;
};

const renderKnowledgeItem = (section: KhRepoCollapsedItem) => (
  <section key={section.item_id} className="mb-4 last:mb-0">
    <h4 className="mb-1 text-sm font-semibold text-slate-900">
      {section.title}
      {section.partial ? <span className="ml-2 text-xs text-slate-500">(partial)</span> : null}
    </h4>
    <h5 className="mb-1 text-xs text-slate-700">
      <a
        href={`mailto:${section.author_email}`}
        className="font-semibold text-slate-700 hover:underline"
        title={`Email ${section.author}`}
      >
        {section.author}
      </a>{" "}
      - Last updated on {section.last_updated}
    </h5>
    <p className="m-0 text-sm leading-relaxed text-slate-700">{section.content ?? ""}</p>
  </section>
);

const formatKnowledgeItems = (items: KhRepoCollapsedItem[] = []) => items.map(renderKnowledgeItem);

const KhRepoKnowledgeExpandableText = ({
  rawContent = [],
  variant = "card",
  title = "Raw Knowledge Items",
}: KhRepoKnowledgeExpandableTextProps) => (
  <KhRepoExpandableText
    title={title}
    rawContent={rawContent}
    formattedRawContent={formatKnowledgeItems}
    displayVariant={variant}
  />
);

export default KhRepoKnowledgeExpandableText;
